import { AxiosRequestConfig } from "axios";

export const getFormDetailsConfig = (pdfId: string, addons: boolean): AxiosRequestConfig => {
  return {
    method: "get",
    url: `/site/products?productId=${pdfId}&addons=${addons}`,
  };
};
